<template>
  <div>
    <div v-if="lastsSubscriptions.length>0" class="mt-4">
      <v-row align="center" dense>
        <v-col>
          <h2 class="body-1">Заканчиваются аб-ты</h2>
        </v-col>
        <v-col align="right">
          <v-btn v-if="isPaymentBtnActive" text
                 @click="setCreatePaymentDialog({})" color="accent">
            + Платеж/Аб-т
          </v-btn>
          <v-btn v-if="!allowOnlinePayment && UISettings.allowPages.pagePayments" text to="payments" color="accent">Платежи</v-btn>
        </v-col>
      </v-row>
      <v-divider class="mb-1"></v-divider>
      <v-layout column>
        <v-flex v-for="sub of lastsSubscriptions" :key="sub.id" class="mb-2">
          <user-subscription-card :subscription="sub"></user-subscription-card>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="debtSubscriptions.length>0 || debtJoins.length>0" class="mt-4">
      <v-row align="center" dense>
        <v-col>
          <h2 class="body-1">Подходит срок оплаты/есть долг</h2>
        </v-col>
        <v-col align="right">
          <v-btn v-if="allowOnlinePayment" text
                 @click="setCreatePaymentDialog({})" color="accent">
            + Платеж/Аб-т
          </v-btn>
          <v-btn v-if="!allowOnlinePayment && UISettings.allowPages.pagePayments" text to="payments" color="accent">Платежи</v-btn>
        </v-col>
      </v-row>

      <v-divider class="mb-1"></v-divider>
      <v-layout column>
        <v-flex v-for="sub of debtSubscriptions" :key="sub.id" class="mb-2">
          <user-subscription-card :subscription="sub"></user-subscription-card>
        </v-flex>
        <v-flex v-for="join of debtJoins" :key="join.id" class="mb-2">
          <user-join-card :join="join"></user-join-card>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import UserSubscriptionCard from './UserSubscriptionCard.vue';
import UserJoinCard from './UserJoinCard.vue';

export default {
  name: 'UserWarnings',
  components: {
    UserJoinCard,
    UserSubscriptionCard,
  },
  data: () => ({}),
  computed: {
    lastsSubscriptions() {
      return this.userSubscriptions
        .filter(sub => ((sub.endDate && -moment().diff(sub.endDate, 'days') <= 7)
          || (sub.visitCount && (sub.visitCount - sub.visitedCount <= 2))) && sub.statusId !== 4);
    },
    debtSubscriptions() {
      return this.userSubscriptions
        .filter(sub => (sub.price > 0 && sub.payed < sub.price && sub.statusId !== 4));
    },
    debtJoins() {
      return this.currentUser.joins
        .filter((join) => {
          const cl = this.classes.find(c => c.id === join.classId);
          return (cl && cl.payType === 'full' && join.price > 0 && join.stats.totalPayed < join.price)
            || (cl && cl.payType === 'lessons' && join.stats.nonPayedLessons > 0);
        });
    },
    currentUserId() {
      return this.currentUser.id;
    },
    isPaymentBtnActive() {
      return this.allowOnlinePayment
      && (this.UISettings.onlinePayment.depositOnBalans
      || (this.allowedClassIds && this.allowedClassIds.length));
    },
    ...mapGetters(['currentUser', 'userSubscriptions', 'classes', 'allowOnlinePayment', 'UISettings', 'allowedClassIds']),
  },
  methods: {
    ...mapMutations(['setCreatePaymentDialog']),
  },
};
</script>

<style scoped>

</style>
